import { AppNavigationProvider } from '@euler/app/components/AppNavigationProvider';
import { BackIcon } from '@euler/app/components/icons/BackIcon';
import { BackButton } from '@euler/app/flows/task/pages/inspection/site-inspection/BackButton';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { MultilineHeaderTitle } from '@euler/components/MultilineHeaderTitle';
import { FontFamily } from '@euler/components/typography';
import { useTrackNavigator } from '@euler/functions/navigatorTracking';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { spreadScreens } from '@euler/functions/spreadScreens';
import { VehicleServiceInfo } from '@euler/services';
import { NavigationContainer } from '@react-navigation/native';
import {
  createStackNavigator,
  TransitionPresets,
} from '@react-navigation/stack';
import { memo } from 'react';
import { HistoricalServiceInfoScreens } from './Screens';

const Stack = createStackNavigator();

export const HistoricalServiceInfoNavigator = memo(
  ({
    onCancel,
    ...props
  }: {
    serviceInfo: VehicleServiceInfo;
    onCancel?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const { ref, onStateChange, onReady } = useTrackNavigator(
      'historical-service-info/',
    );

    return (
      <AppNavigationProvider>
        <LayoutProviderView
          fallbackToChildren
          style={{ flex: 1, justifyContent: 'flex-start' }}
        >
          <NavigationContainer
            documentTitle={{ enabled: false }}
            ref={ref}
            onReady={onReady}
            onStateChange={onStateChange}
            independent={true}
            onUnhandledAction={action => {
              if (action.type === 'POP') {
                onCancel?.();
              }
            }}
          >
            <Stack.Navigator
              initialRouteName="_record"
              screenOptions={{
                ...TransitionPresets.SlideFromRightIOS,
                headerStatusBarHeight: 0,
                headerMode: 'float',
                headerTitleAlign: 'center',
                headerBackTitle: ' ',
                headerTitleStyle: {
                  fontSize: rpx(18),
                  fontFamily: FontFamily.NotoSans.Bold,
                },
                cardStyle: {
                  backgroundColor: '#fff',
                },
                headerTitle: MultilineHeaderTitle,
                headerLeft: () => (
                  <BackButton>
                    <BackIcon />
                  </BackButton>
                ),
              }}
            >
              {spreadScreens(
                Stack.Screen,
                HistoricalServiceInfoScreens,
                '_serviceInfo',
                props,
              )}
            </Stack.Navigator>
          </NavigationContainer>
        </LayoutProviderView>
      </AppNavigationProvider>
    );
  },
);
